<template>
  <div>
    <div class="row">
      <div class="col-md-5 mx-auto pt-3">
        <div id="first">
          <div class="myform form">
            <div class="logo mb-3">
              <div class="col-md-12 text-center rounded bg-primary p-4">
                <img class="img-fluid" src="/static/img/christianLibrary.png" />
                <h3 class="pt-5">{{ $t("Login") }}</h3>
              </div>
            </div>
            <!-- <form action="" method="post" name="login"> -->
            <div class="form-group">
              <!-- <label for="exampleInputEmail1">{{ $t("userName") }}</label> -->
              <input
                label="userName"
                type="email"
                name="email"
                class="form-control"
                id="email"
                v-model="userName"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>

            <div class="form-group">
              <!-- <label for="exampleInputEmail1">{{ $t("password") }}</label> -->
              <input
                label="password"
                type="password"
                name="password"
                id="password"
                class="form-control"
                v-model="password"
                aria-describedby="emailHelp"
                placeholder="Enter password"
              />
            </div>

            <div class="form-group">
              <p class="text-center">
                {{ $t("cantRememberYourPassword") }}
                <a href="#">{{ $t("ResetItHere") }}</a>
              </p>
            </div>

            <div class="col-md-12 text-center">
              <button
                type="submit"
                class="
                  rounded-pill
                  text-white
                  btn btn-primary btn-block
                  mybtn
                  tx-tfm
                "
                @click="loginJWT"
              >
                {{ $t("Login") }}
              </button>
            </div>

            <hr class="hr-or" />

            <div class="form-group">
              <p class="text-center">
                {{ $t("Don'tHaveAccount") }}
                <a href="#" id="signup" @click="SignupUser()">{{
                  $t("Signuphere")
                }}</a>
              </p>
            </div>

            <div class="col-md-12">
              <div class="login-or">
                <div class="text-center">
                  <span class="span-or">- {{ $t("or") }} -</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8 mx-auto">
                <fb-signin-button class="mb-1" />
                <g-signin-button @done="onUserLoggedIn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

Vue.component("fb-signin-button", {
  template:
    '<div  id="FbSigninBtn" ref="FbSigninBtn" class="fb-login-button"  data-width="2000"  data-size="large" data-button-type="login_with" data-layout="rounded" data-auto-logout-link="false" data-use-continue-as="true" data-scope="email" ></div>',
  mounted() {
    debugger;
    window.fbAsyncInit = () => {
      FB.init({
        // appId: "237256045148233",
        appId: "228490429716131",
        cookie: true,
        status: true,
        xfbml: true,
        version: "v10.0",
      });

      FB.Event.subscribe("auth.login", (response) => {
        /* make the API call */
        console.log(response);
        FB.api(
          "/me",
          {
            fields: "name, email",
          },
          function (response) {
            console.log(response.email);
            console.log(response.name);
            var Model = {
              name: response.name,
              email: response.email,
              provider: "facebook",
              // provider_Id: "237256045148233",
              provider_Id: "228490429716131",
              fireBaseToken: "",
              profilePic: "",
            };
            window.store.dispatch("auth/SocialLogin", Model);
          }
        );

        // do something with response
        // FB.login(
        //   function(response) {
        //     // handle the response
        //     console.log(response);
        //   },
        //   { scope: "public_profile,email" }
        // );
      });
      FB.getLoginStatus((response) => {
        if (response.status === "connected") {
          console.log(response);
          // The user is logged in and has authenticated your
          // app, and response.authResponse supplies
          // the user's ID, a valid access token, a signed
          // request, and the time the access token
          // and signed request each expire.
          var uid = response.authResponse.userID;
          var accessToken = response.authResponse.accessToken;
          FB.login(
            function (response) {
              // handle the response
              console.log(response);
            },
            { scope: "public_profile,email" }
          );
          FB.api(
            "/" + response.userID + "/?fields=id,name,email",
            "GET",
            {},
            function (response) {
              // Insert your code here
              // console.log(response);
              let email = response.email;
              console.log(email);
            }
          );

          FB.logout(function (response) {
            console.log(response);
            // user is now logged out
          });
        } else if (response.status === "not_authorized") {
          // The user hasn't authorized your application.  They
          // must click the Login button, or you must call FB.login
          // in response to a user gesture, to launch a login dialog.
        } else {
          // The user isn't logged in to Facebook. You can launch a
          // login dialog with a user gesture, but the user may have
          // to log in to Facebook before authorizing your application.
        }
      });
      FB.login((response) => {
        console.log(response);
      });
      FB.AppEvents.logPageView();

      FB.getAuthResponse((response) => {
        debugger;
        // body...
        FB.api(
          "/" + response.userID + "/?fields=id,name,email",
          "GET",
          {},
          function (response) {
            // Insert your code here
            // console.log(response);
            let email = response.email;
            console.log(email);
          }
        );
        console.log(response);
        debugger;
        statusChangeCallback(response);
      });
    };
    (function (document, s, id) {
      var js,
        fjs = document.getElementsByTagName(s)[0];
      if (document.getElementById(id)) {
        return;
      }
      js = document.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
    // debugger;
    var js,
      id = "facebook-jssdk";
    if (document.getElementById(id)) {
      return;
    }
    js = document.createElement("script");
    js.id = id;
    js.async = true;
    js.src = "//connect.facebook.net/en_US/all.js";
    document.getElementsByTagName("head")[0].appendChild(js);

    window.fbAsyncInit("init", () => {
      const FB = window.FB.init({
        appId: "265548035024898",
        cookie: true,
        xfbml: true,
        version: "v10.0",
        autoLogAppEvents: true,
      });
      FB.attachClickHandler(
        this.$refs.FbSigninBtn,
        {},
        (googleUser) => {
          this.$emit("done", googleUser);
        },
        (error) => console.log(error)
      );

      FB.getAuthResponse(function (response) {
        debugger;
        console.log(response);
        debugger;
        statusChangeCallback(response);
      });
    });
  },
});

Vue.component("g-signin-button", {
  template:
    '<div ref="signinBtn"><a style="color:#4285F4" class="mb-3 border shadow rounded-pill  btn btn-white btn-block mybtn tx-tfm"> <i  class="fa fa-google fa-fw"></i> Login with Google</a ></div>',
  mounted() {
    window.gapi.load("auth2", () => {
      const auth2 = window.gapi.auth2.init({
        client_id:
          "334917801561-lcuv39tkltngn4bbq7dkj9e40b1pbkil.apps.googleusercontent.com",
        cookiepolicy: "single_host_origin",
      });
      auth2.attachClickHandler(
        this.$refs.signinBtn,
        {},
        (googleUser) => {
          this.$emit("done", googleUser);
        },
        (error) => console.log(error)
      );
    });
  },
});

export default {
  data() {
    return {
      checkbox_remember_me: false,
      userName: "",
      password: "",
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.userName != "" && this.password != "";
    },
  },
  methods: {
    FbSigninBtn() {
      alert("S");
      debugger;
      window.FB.login((response) => {
        console.log(response);
        if (response.authResponse) {
          console.log("Welcome!  Fetching your information.... ");
          FB.api("/me", function (response) {
            console.log("Good to see you, " + response.name + ".");
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      });
    },
    onUserLoggedIn(googleUser) {
      console.log(googleUser);
      var profile = googleUser.getBasicProfile();
      console.log("ID: " + profile.getId()); // Do not send to your backend! Use an ID token instead.
      console.log("Name: " + profile.getName());
      console.log("Image URL: " + profile.getImageUrl());
      console.log("Email: " + profile.getEmail()); // This is null if the 'email' scope is not present.
      var Model = {
        name: profile.getName(),
        email: profile.getEmail(),
        provider: "google",
        provider_Id:
          "1097401738041-sslg7qpmrimqv1d6jjda7l6bdeli7420.apps.googleusercontent.com",
        fireBaseToken: "",
        profilePic: profile.getImageUrl(),
      };
      this.$store
        .dispatch("auth/SocialLogin", Model)
        .then((response) => {
          if (response.status == 200) {
            debugger;
            this.$router.push("/Home");
          }
        })

        .catch(() => {});
      // console.log(googleUser);
    },
    checkLogin() {
      // If user is already logged in notify
      debugger;
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$router.push("/Home");
        return false;
      }
      debugger;
      return true;
    },
    loginJWT() {
      if (!this.checkLogin()) {
        return;
      }

      if (!this.validateForm) {
        window.showFillData();
        return;
      }
      // this.$vs.loading();--

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          userName: this.userName,
          password: this.password,
        },
      };
      this.$store
        .dispatch("auth/loginJWT", payload)
        .then((response) => {
          if (response.status == 200) {
            debugger;
            this.$router.push("/Home");
          }
        })

        .catch((error) => {
          debugger;
          if (error.response) {
            if (error.response.status == 400) {
              debugger;
              error.response.data.Error;
              debugger;
              if (error.response.data.Error == "password") {
                this.$vs.notify({
                  title: this.$t("Error"),
                  text: this.$t("InvalidPasswordPleasetryagain"),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              } else if (error.response.data.Error == "userName") {
                this.$vs.notify({
                  title: this.$t("Error"),
                  text: this.$t("InvalidEmailPleasetryagain"),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              } else if (error.response.data.Error == "Account is Not Active") {
                this.$vs.notify({
                  title: this.$t("Error"),
                  text: this.$t("SorryYouAccountisNotActive"),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              } else {
                debugger;
                // this.$vs.notify({
                //   title: this.$t("Error"),
                //   text: this.$t("NotFound"),
                //   iconPack: "feather",
                //   icon: "icon-alert-circle",
                //   color: "danger",
                //      position: "top-center",
                // });
                console.log("This account Not found"); // Do not send to your backend! Use an ID token instead.
              }
            } else {
              this.$vs.notify({
                title: this.$t("Error"),
                text: this.$t("somethingwentwrong"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
              });
            }
          } else {
            this.$vs.notify({
              title: this.$t("Error"),
              text: this.$t("somethingwentwrong"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    SignupUser() {
      if (!this.checkLogin()) {
        return;
      }
      this.$router.push("/signup").catch(() => {});
    },
  },
  created() {
    // localStorage.clear();
    this.checkLogin();
  },
};
</script>
<style>
#FbSigninBtn {
  margin-right: 3rem !important;
  width: 35rem !important;
  margin-bottom: 1rem !important;
}
</style>
